import angular from 'angular';
const module = angular.module('whyline.components.status', []);

const statusComponent = {
  bindings: {
    item: '=',
    lang: '@',
    color: '<'
  },
  templateUrl: '/templates/components/status.html',
  controller($scope) {
    'ngInject';
    $scope.getStatus = () => {
      // No queue provided
      if(!this.item) {
        return '';
      }

      // Queue type Area
      if(this.item.realType === 'process') {
        return 'icon-process';
      } else if(this.item.realType === 'group') {
        return 'icon-group';
      } else if(this.item.realType === 'supervisor') {
        return 'icon-supervisor';
      } else if(this.item.realType === 'line' && !this.color) {
        return `icon-line-${this.lang}`;
      } else if(this.item.realType === 'line') {
        return this.item.color;
      } else {
        return '';
      }
    };
  },
};

module.exports = module.component('status', statusComponent);
